import axios from '../utils/axios';

export default function createSeekerSubscription(adminId,data) {
    return (
        axios.post('/admin/' + adminId + '/manageSeekerSubscriptions/subscription/admin/create-order?type=ea', data )
    )
}
